<template>
  <div class="login-container">
    <div class="login-center-container">
      <div id="screens">
        <img src="/static/img/illus-base.png" alt="Base" id="base">
        <img src="/static/img/illus-camembert.png" alt="Camembert" id="camembert">
        <img src="/static/img/illus-ecran1.png" alt="Ecran1" id="screen1">
        <img src="/static/img/illus-ecran2.png" alt="Ecran2" id="screen2">
      </div>

      <!-- Card -->
      <div class="login-box">

        <img class="login-logo" src="/static/img/logo/logo.svg" alt="Logo du logiciel de gestion d'affaire PACMAN" />

        <div v-show="!recoveryForm" id="loginForm">
          <!-- Form Login -->
          <b-form @submit.stop.prevent="loginAndGoDashboard"
                  id="app-login-form">

            <!-- Email or username -->
            <b-form-group id="loginGroup">
                          <!--label="Adresse email / Nom d'utilisateur"-->
                          <!--label-for="login">-->
              <b-form-input id="login"
                            type="text"
                            v-model="formLogin.login"
                            required
                            placeholder="Entrez votre adresse email">
              </b-form-input>
            </b-form-group>

            <!-- Password -->
            <b-form-group id="passwordGroup">
                          <!--label="Mot de passe"-->
                          <!--label-for="password">-->
              <b-form-input id="password"
                            type="password"
                            v-model="formLogin.password"
                            required
                            placeholder="Entrez votre mot de passe">
              </b-form-input>

              <!-- Alert -->
              <b-alert class="login-alert-bad-credentials"
                      variant="danger"
                      :show="showAlertBadCredentials">
                Login et/ou mot de passe incorects
              </b-alert>
            </b-form-group>
          </b-form>

          <div id="submitForm">
            <!-- Submit login form -->
            <b-button
                    form="app-login-form" class="login-submit"
                    type="submit"
                    variant="primary">
              Se connecter
            </b-button>
            <!-- Omit password -->
            <b-link variant="primary" class="login-reset-password-link" @click="toggleRecovery(true)">
              Mot de passe perdu ?
            </b-link>
          </div>
        </div>

        <b-form-group id="recovery" v-show="recoveryForm">
          <b-form @submit.stop.prevent="resetPassword" id="app-reset-password-form">
            <b-form-group id="passwordGroup"
                          label="Renseignez votre adresse email"
                          label-align="center"
                          label-for="resetPasswordEmail">
              <b-form-input id="resetPasswordEmail"
                            type="email"
                            v-model="formResetPassword.email"
                            required
                            placeholder="exemple@exemple.com"/>
            </b-form-group>

            <div id="passwordResetGroup">
              <b-button class="form-reset-password-submit"
                        type="submit"
                        form="app-reset-password-form"
                        variant="primary">Envoyer</b-button>

              <b-button variant="danger" @click="toggleRecovery(false)">Annuler</b-button>
            </div>
          </b-form>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import router from '../../../router';

export default {
  name: 'Login',
  data() {
    return {
      msg: 'Bienvenue sur l\'application de gestion d\'affaires',
      formLogin: {
        login: '',
        password: '',
      },
      formResetPassword: {
        email: '',
      },
      showSpinner: false,
      showAlertBadCredentials: false,
      showAlertResetPasswordEmailSent: false,
      recoveryForm: false,
    };
  },
  methods: {
    ...mapActions([
      // 'getUserById',
      'getMe',
    ]),
    loginAndGoDashboard(event) {
      let formData = new FormData();
      formData.append('login', this.formLogin.login);
      formData.append('password', this.formLogin.password);

      axios.post('users/login', formData)
            .then((response) => {
              // Set token and redirect to dashboard
              if (window.$cookies.get('authToken')) {
                window.$cookies.remove('authToken');
              }

              let cookieTime = '0';

              if (this.rememberMe == 'yes') {
                cookieTime = '30d';
              }

              // Setting session cookie
              window.$cookies.set('authToken', response.data.token, cookieTime);

              // Updating store object
              this.getMe();

              this.$router.push({ name: 'dashboard' });
            })
            .catch((error) => {
              const toast = {
                  show: true,
                  variant: 'danger',
                  duration: 5000,
              };

              if (error.response.status === 401) {
                toast.message = 'Impossible de se connecter. Merci de vérifier vos identifiants.';
              } else if (error.response.status === 403) {
                toast.message = 'Un utilisateur existe déjà avec cette adresse email.';
              } else {
                console.log(error);
              }
              this.$store.commit('setGlobalToaster', toast);
            });
    },
    resetPassword(event) {
      let formData = new FormData();
      formData.append('email', this.formResetPassword.email);

      axios.post('users/reset/password', formData)
        .then(() => {
          // Show success toast
          const toast = {
            show: true,
            message: 'Un email de confirmation vous a été envoyé à l\'adresse fournie.',
            variant: 'success',
            duration: 5000,
          };
          this.$store.commit('setGlobalToaster', toast);

          // Reset form
          this.formResetPassword.email = '';

          this.toggleRecovery(false);
        })
        .catch((error) => {
          console.error(error.message);
        })
      ;
    },
    toggleRecovery(bool) {
      this.recoveryForm = bool;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.login-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;
  overflow: hidden;

  .login-center-container {
    display: flex;
    flex-direction: columns;
    justify-content: center;
    align-items: center;

    .login-box {
      width: 490px;
      padding: 70px;
      background-color: #fff;
      box-shadow: 0 0 15px rgba(0,0,0,.1);
      border-radius: 5px;
      border: 0;
      z-index: 9;
      position: relative;
      left: 250px;

      @media screen and (max-width: 1200px) {
        left: initial;
      }

      .form-group {
        margin-bottom: 30px;
      }

      img {
        margin-bottom: 70px;
      }
    }
  }

  @media screen and (max-width: 1200px) {
    justify-content: center;
    margin-left: 0;
  }
}

#screens {
  position: absolute;
  top: 0;
  right: 60px;
}

#base {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}

#camembert {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  animation: cam 10s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

#screen1 {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  animation: screen 10s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  animation-delay: 2.5s;
}

#screen2 {
  position: absolute;
  top: 15px;
  right: 0;
  z-index: 0;
  animation: screen2 10s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  animation-delay: 1.75s;
}

@keyframes cam {
	0% {
    top: 0px;
    right: -2px;
	}
	50% {
    top: 2px;
    right: -16px
  }
  100% {
    top: 0px;
    right: -2px;
  }
}

@keyframes screen {
  0% {
    top: 0;
  }
  50% {
    top: 20px;
  }
  100% {
    top: 0;
  }
}

@keyframes screen2 {
  0% {
    top: 15px;
  }
  50% {
    top: 0;
  }
  100% {
    top: 15px;
  }
}

.login-reset-password-link {
  display: block;
  text-align: center;
  margin-top: 15px;
}

#collapse1 {
  border-top: 1px solid #c0c0c0;
  padding-top: 30px;
}

#submitForm {
  margin-bottom: 0;
}

#loginForm,
#submitForm {
  display: flex;
  flex-direction: column;
}

#passwordResetGroup {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/security/Login.vue